module.exports = __webpack_public_path__ + "static/media/cafe-majomut-ok.a4f87e6d.jpg";